import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadAnotaAi: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"ANOTA_AI"} title={"Importar catálogo Anota AI"}
  instructions={"Copie o link público da loja no Anota AI. Links antigos no formato /m/ID também são aceitos."}
  placeholder={"https://app.anota.ai/sua-loja"} />;

export default UploadAnotaAi;
